import React from 'react';
import DischargePatientList from './DischargePatientList';

const DischargeMyPatients: React.FC = () => <DischargePatientList ownershipFilter="MY" />;

export default DischargeMyPatients;
